import { AST } from '@handlebars/parser';
import { joinWithEquals, joinWithSpaces } from 'utils/stringHelpers';
import { ExpressionSerializer } from '../expression/serializer';

/**
 * Utility class for converting `AST.Hash` to a Handlebars template string
 */
export class HashSerializer {
  /**
   * Serializes any `AST.Hash` into a Handlebars template sting
   */
  static serialize = (hash: AST.Hash) =>
    joinWithSpaces(hash.pairs.map(HashSerializer.serializeHashPair));

  // Private helper functions:
  private static serializeHashPair = ({ key, value }: AST.HashPair) =>
    joinWithEquals([key, ExpressionSerializer.serialize(value)]);
}
